import { IGuideState } from "../../widgets/interfaces/model/index";
import { createReducers } from "../util";
import { resetGuides, setGuides, setGuideSnapDetails } from "./GuideOperation";

/**
 * Default state for guides
 */
const initialState: IGuideState = {
	guides: [],
	snapXToGuides: false,
	snapYToGuides: false,
};

/**
 * Action constants for guides operations
 */

export enum GuideActionConstants {
    RESET_GUIDES= "RESET_GUIDES",
    SET_GUIDES = "SET_GUIDES",
    SET_GUIDES_SNAP_DETAILS = "SET_GUIDES_SNAP_DETAILS",
}

/**
 * Guides reducers
 */
export const guides = createReducers(initialState, {
	[GuideActionConstants.SET_GUIDES]: setGuides,
	[GuideActionConstants.RESET_GUIDES]: resetGuides,
	[GuideActionConstants.SET_GUIDES_SNAP_DETAILS]: setGuideSnapDetails,
});
